import React from 'react';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  tone?: 'dark' | 'panel';
};
export function Section({
  id,
  children,
  className = '',
  tone = 'dark'
}: SectionProps) {
  const bg = tone === 'panel' ? 'bg-ink-900' : 'bg-ink';
  return <section id={id} className={`w-full ${bg} px-4 py-12 sm:px-6 sm:py-16 ${className}`} data-id="element-56" data-mp="3kv8a0byd5wqq">
      <div className="mx-auto w-full max-w-5xl" data-id="element-57" data-mp="cfwut85jxpog">{children}</div>
    </section>;
}
type SectionTitleProps = {
  eyebrow?: string;
  children: React.ReactNode;
  subtitle?: string;
};
export function SectionTitle({
  eyebrow,
  children,
  subtitle
}: SectionTitleProps) {
  return <header className="mx-auto max-w-3xl text-center" data-id="element-58" data-mp="2o0xhzbai3la">
      {eyebrow ? <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.2em] text-teal-bright sm:text-xs" data-id="element-59" data-mp="7n3uqxl135ip">
          {eyebrow}
        </p> : null}
      <h2 className="font-display text-[26px] font-bold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-60" data-mp="105rcc30tg2f1">
        {children}
      </h2>
      {subtitle ? <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-white/60 sm:text-base" data-id="element-61" data-mp="2zihe8ahki7mc">
          {subtitle}
        </p> : null}
    </header>;
}